export const isProduction = !["localhost", "127.0.0.1"].includes(window.location.hostname);

export const API_BASE_URL_LOCAL = 'http://localhost:8000/api/v1';
export const API_BASE_URL_PRODUCTION = 'https://inteliqr-menu-comercial-api-6tvmjjrxqa-uc.a.run.app/api/v1';

export const API_BASE_URL = isProduction ? API_BASE_URL_PRODUCTION : API_BASE_URL_LOCAL;

export const HEADERS_WITH_TOKEN = (token) => {
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  }
}

export const HEADERS_WITH_TOKEN_WITHOUT_CONTENTTYPE = (token) => {
  return {
    'Authorization': `Bearer ${token}`
  }
}

